const detectIE = function () {
	const html = document.querySelector('html');
	if (navigator.appVersion.indexOf('MSIE') != -1 || navigator.appVersion.indexOf('Trident') != -1 || navigator.appVersion.indexOf('Edge') != -1) {
		html.classList.add('ie');
	} else {
		html.classList.remove('ie');
	}
};

detectIE();